import { PaginatedProps } from "../Components/CoreLib/library";

/**
 * Converts PaginatedProps sorting information to an array of sort strings.
 * If the `sorting` array is provided and not empty, it converts each item to "key+" or "key-".
 * Otherwise, it falls back to using `sortKey` and `sortAsc` to create a single-item array.
 * 
 * @param paginatedProps - The paginated props containing sorting information
 * @returns An array of sort strings in the format "key+" for ascending or "key-" for descending
 */
export function buildUpdatedSortingFromPaginationProps(paginatedProps?: PaginatedProps): string[] {
    if (paginatedProps?.sorting && paginatedProps.sorting.length > 0) {
        return paginatedProps.sorting.map((item) => item.key + (item.direction === 'asc' ? '+' : '-'));
    }
    
    if (paginatedProps?.sortKey) {
        return [paginatedProps.sortKey + (paginatedProps.sortAsc ? '+' : '-')];
    }
    
    return [];
}

